<template>
	<div>
		<toast></toast>
		<div class="col-md-4 pt-3 centre_sm_none">
			<div class="risk_list">
				<ul class="list-group">
					<li class="risk_list_tit list-group-item">
						<i class="fa fa-file-text fa-lg mr-2"></i> 投资风险报告
						<button class="btn">
							<router-link :to="{name:'countryreport'}">选择国家</router-link>
							
						</button>
					</li>
					<li class="list-group-item risk_list_tite">
						<button @click="reporttabs(1)" :class="{'btn_active':reporttab==1}" class="btn">投资风险报告</button>
						<button @click="reporttabs(2)" :class="{'btn_active':reporttab==2}" class="btn">公共安全报告</button>
					</li>
					<li v-show="reporttab===1" class="card text-center nano video_breviary">
						<div class="card-body nano-content" id="reports_jieshao">
							<div v-for="(value,key) in investmentLists" v-if="value.catname == '投资建议'">
								<h5 class="card-title">{{countrynames}}投资建议</h5>
								<img :src="value.thumb" class="img-thumbnail w-50" style="margin: 20px 0px;">

								<p class="card-text" style="font-size: 14px;color: #4E5671;line-height: 23px;">
									{{value.description}}
								</p>
							</div>
						</div>
					</li>
					<li v-show="reporttab===2" class="card text-center nano video_breviary">
						<div class="card-body nano-content" id="reports_jieshao">
							<div v-for="(value,key) in anquanLists" v-if="value.catname == '风险分析'">
								<h5 class="card-title">{{countrynames}}投资建议</h5>
								<img :src="value.thumb" class="img-thumbnail w-50" style="margin: 20px 0px;">
								<p class="card-text" style="font-size: 14px;color: #4E5671;line-height: 23px;">
									{{value.description}}
								</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<div class="col-md-8 pl-0 mt-3 risk_content centre_sm_none">

			<ul class="list-group">
				<li class="list-group-item">
					<span style="line-height: 38px;">{{countrynames}}
						<span class="reporttype">投资风险报告</span>
					</span>
					<div style="float: right;display: inline-flex;">
						<div class="dropdown" @click="createrecord()">
							<button type="button" class="btn btn-custom dropdown-toggle" data-toggle="dropdown">
								报告生成记录
							</button>
							<div class="dropdown-menu">

								<li class="dropdown-item" v-for="(value,key) in createrecords">
									<a :href="value.url" class="text-dark" target="_blank">
										<span class="mr-3 f14">{{value.nation}}</span>
										<span class="f14">{{value.time}}</span>
									</a>
								</li>
							</div>
						</div>
						<button type="button" @click="generatereport($event)" class="btn btn-primary" style="margin-left: 20px;">
							一键生成报告
						</button>
					</div>

				</li>
				<div class="row nano p-0 m-0 one_title_nano">
					<div class="nano-content">
						<li class="list-group-item risk_list_tite  risk_list_content p-0 m-0">
							<div class="row m-0">
								<div class="col-md-2 col-2 p-0">
									<ul class="list-group" style="border-right: 1px solid #f3f4f5;">
										<li class="list-group-item my_protocol">
											<input @click="checkAll($event)" id="quan" class="input_agreement_protocol" type="checkbox" /> 全选
										</li>
										<li v-for="(value,key) in investmentLists" class="list-group-item my_protocol">
											<input class="input_agreement_protocol checkItem" v-model="checkData" type="checkbox" :value="value.id" /> {{value.catname}}
										</li>

									</ul>
								</div>
								<div class="col-md-10 col-10 risk_report_content">
									<p v-for="(value,key) in investmentLists" v-html="value.content" class="p-0">

									</p>
								</div>
							</div>
						</li>
					</div>
				</div>
			</ul>
		</div>

	</div>
</template>
<script>
	import toast from './toast/Toast'
	export default({
		name: 'riskreports',
		data: function() {
			return {
				reporttab: 1,
				investmentLists: [],
				anquanLists: [],
				checkData: [], //全选
				createrecords: [],
				toastText: '',
				countrynames: ''
			}
		},
		created: function() {
			var self = this;
			var countryid = this.$route.params.id;

			var countryname = this.$route.params.countryname;
			self.countrynames = countryname;

			this.$axios.post('/api/pc/getreportcontent', {
				proid: countryid,
				type: 1
			}).then(data => { //风险投资
				var investmentList = data.data.data;
				self.investmentLists = investmentList;
			})
		},
		mounted() {
			this.load();
		},
		watch: { // 监视双向绑定的数据数组
			checkData: {
				handler() { // 数据数组有变化将触发此函数
					//                  if(this.checkData.length == 1){
					//                      document.querySelector('#quan').checked = true;
					//                  }else {
					//                      document.querySelector('#quan').checked = false;
					//                  }
				},
				deep: true // 深度监视
			}
		},
		methods: {
			checkAll(e) { // 点击全选事件函数
				var checkObj = document.querySelectorAll('.checkItem'); // 获取所有checkbox项
				if(e.target.checked) { // 判定全选checkbox的勾选状态
					for(var i = 0; i < checkObj.length; i++) {
						if(!checkObj[i].checked) { // 将未勾选的checkbox选项push到绑定数组中
							this.checkData.push(checkObj[i].value);
						}
					}
				} else { // 如果是去掉全选则清空checkbox选项绑定数组
					this.checkData = [];
				}
			},
			reporttabs(index) {
				var countryid = this.$route.params.id;
				this.reporttab = index;
				var countryname = this.$route.params.countryname;
				this.countrynames = countryname;
				let that = this;
				var reporttypes = $(".reporttype").text();

				if(reporttypes == '公共安全报告') {
					$(".reporttype").text('风险投资报告')
				} else {
					$(".reporttype").text('公共安全报告')
				}

				this.$axios.post('/api/pc/getreportcontent', {
					proid: countryid,
					type: index
				}).then(data => { //风险投资

					var anquanList = data.data.data;
					that.anquanLists = anquanList;

				});
				this.$axios.post('/api/pc/getreportcontent', {
					proid: countryid,
					type: index
				}).then(data => { //风险投资
					var investmentList = data.data.data;
					that.investmentLists = investmentList;

					if(that.investmentLists) {
						$(".one_title_nano").show();
					} else {
						$(".wrap").text('暂无数据');
						$(".wrap").show().delay(1500).hide(100);
						
						$(".one_title_nano").hide();

					}
				})

			},
			createrecord() {

				this.$axios.post('/api/pc/getrecord', {
					memberid: 53,
					stateid: 1
				}).then(data => { //生成报告记录
					var createrecord = data.data.data;
					this.createrecords = createrecord;

				})
			},
			generatereport(e) {

				var countryid = this.$route.params.id;
				var self = this;
				let that = this;
				this.$axios.post('/api/pc/makepdf', {
						memberid: 53,
						type: 1,
						proid: countryid,
						contentids: self.checkData
					})
					.then(data => {
						if(data.data.state == true) {
							$(".wrap").text(data.data.data);
							$(".wrap").show().delay(1500).hide(100);

						} else {
							$(".wrap").text(data.data.error);
							$(".wrap").show().delay(1500).hide(100);
						}
					})
			}
		},
		components: {
			toast
		}
	})
</script>